import { RequestError } from '../../../utils';
import getAzureErrors from './getAzureErrors';

export default (error: RequestError | Error) => {
    try {
        return JSON.stringify(getAzureErrors(error));
    } catch (e) {
        return `Could not stringify errors due to: ${e.message}`;
    }
};
